import { useState } from 'react';

import { PrismicRichText } from '@prismicio/react';

import { ReactSVG } from 'react-svg';

import arrowImg from 'images/arrow-icon.svg';

import { AttributeMessage } from '@components/overlays/AttributeMessage';

import { IProductAttributeButtonProps } from './types';
import * as S from './styles';

export const ProductAttributeButton: React.FC<IProductAttributeButtonProps> = ({
  attribute,
}) => {
  const [show, setShow] = useState(false);

  return (
    <S.Wrapper>
      <AttributeMessage
        hide={() => setShow(false)}
        show={show}
        attribute={attribute}
      />
      <S.Button type="button" onClick={() => setShow(true)}>
        <S.Text>
          {attribute?.message && <PrismicRichText field={attribute.message} />}
        </S.Text>
        <S.Icon>
          <ReactSVG src={arrowImg} />
        </S.Icon>
      </S.Button>
    </S.Wrapper>
  );
};

ProductAttributeButton.displayName = 'ProductAttributeButton';
